import React, { useEffect } from 'react'
import Navbar from './components/Navbar'
import Hero from './components/Hero'
import Steps from './components/Steps'
import Feedback from './components/Feedback'
import Footer from './components/Footer'
import AOS from "aos";
import "aos/dist/aos.css";
import ReactGa from 'react-ga';

const Tracking_id=`UA-206632010-1`;
ReactGa.initialize(Tracking_id);


const App = () => {
  
useEffect(() => {
  AOS.init();
  AOS.refresh();
}, []);
  return (
    <>
        <Navbar/>
       <div className="transition-all duration-300 px-3 md:w-[80%] mx-auto  md:px-0 ">
       <Hero/>
       <Steps />
       <Feedback/>
       </div>
       <Footer/>
    </>
  )
}

export default App